var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"font-weight-medium grey--text text--darken-2 mr-4 text-subtitle-2"},[_c('v-icon',{staticClass:"mr-1 my-1",attrs:{"color":"primary"}},[_vm._v(" mdi-account-circle ")]),_vm._v(" "+_vm._s(_vm.name)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }